/* BYO Gift Set: budget, box picture, packing and cart. Markup in sections/hkk-byo-gift-set.liquid. */
(() => {
  'use strict';
  const section = document.querySelector('[data-hkk-path="byo"]');
  if (!section) return;
  const $ = (sel) => section.querySelector(sel);
  const $$ = (sel) => section.querySelectorAll(sel);
  const ITEMS = JSON.parse($('[data-items]').textContent);
  const BOX_ID = +section.dataset.box;

  /* ---------- Money: format like Shopify's money filter for this market (same trick as the Omakase card) ---------- */
  const sample = section.dataset.money, m = sample.match(/\d[\d.,' ]*\d/), num = m[0], si = m.index, sj = si + num.length;
  const thou = num.charAt(1), dec = /\D89$/.test(num) ? num.charAt(num.length - 3) : '';
  const money = (cents) => {
    const neg = cents < 0 ? '-' : '';
    const [whole, frac] = (Math.abs(cents) / 100).toFixed(2).split('.');
    return neg + sample.slice(0, si) + whole.replace(/\B(?=(\d{3})+(?!\d))/g, thou) + (dec ? dec + frac : '') + sample.slice(sj);
  };
  // Budgets are ringgit; prices arrive in the shopper's currency, so convert the budget with the market rate.
  const RATE = Number((window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1) || 1;
  const rm = (ringgit) => Math.round(ringgit * 100 * RATE);

  /* ---------- Constants to calibrate against two or three real packed boxes ---------- */
  const BOX_L = 42, BOX_W = 34, BOX_H = 25;                 // inside, cm
  const BOX_VOLUME_CM3 = BOX_L * BOX_W * BOX_H;             // 35,700
  const BOX_WEIGHT_LIMIT_G = 20000;
  const BOX_USABLE_FRACTION = 0.9;                          // share of the volume items can really use once paper and gaps are in
  const PACKING_FACTOR = { 'Babywear': 0.45, 'Diaper': 1.0, 'Grain': 0.9, 'Cereal': 0.9, 'Pasta': 0.9, 'Snack': 0.9, 'Feeding Essential': 1.15, 'Pacifier': 1.15 };
  const DEFAULT_PACKING_FACTOR = 1.0;
  const GAP_CM = 1;
  const MIN_SPEND_RM = 250, BUDGET_STEP_RM = 50, BUDGET_PRESETS_RM = [250, 300, 400, 500], DEFAULT_BUDGET_RM = 300;

  /* ---------- Stage geometry, in pixels of the 900 x 675 rendering of the top-down photo ---------- */
  const PHOTO_CROP = { x: 100, y: 36, w: 730, h: 580 };
  const FLOOR_PLANE = { x: 273, y: 180, w: 416, h: 316 }; // where the 42 x 34 cm floor maps: the top of the real paper bed in the photo
  const PX_PER_CM_X = FLOOR_PLANE.w / BOX_L, PX_PER_CM_Y = FLOOR_PLANE.h / BOX_W;
  const PARCEL_CM = { x: 32, y: 25, w: 10, h: 9 };        // the mystery gift keeps this front corner (its px spot in hkk-byo.css comes from this)

  /* ---------- Depth cues, from the item's standing height in cm (its smallest dimension) ---------- */
  const SHADOW_OFFSET_PX_PER_CM = 0.9, SHADOW_BLUR_PX_PER_CM = 1.6;
  const HEIGHT_GROW_PER_10CM = 0.03, RISE_SCALE = 0.5, STAGE_PERSPECTIVE_PX = 1000; // the stage's CSS perspective
  const SHRED_OUT_PX = 18, SHRED_IN_FRACTION = 0.1;

  const pct = (x) => Math.round(x * 100) + '%';
  const kg = (g) => (g / 1000).toFixed(g >= 10000 ? 0 : 1);
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  // A cut-out photo is drawn at its footprint's width (upright: standing to face the camera; flat: stretched to fit), so the side
  // across the photo must run across the box: a landscape photo (ua >= 1) shows the long side across, a portrait one the short side.
  // If it cannot lie that way, drop the photos and show the tile.
  ITEMS.forEach((it) => {
    if (!it.upright && !it.flat) return;
    const d = [...it.cm].sort((x, y) => y - x);
    it.across = it.ua >= 1 ? [d[0], d[1]] : [d[1], d[0]];
    if (it.across[0] > BOX_L || it.across[1] > BOX_W) { it.upright = ''; it.flat = ''; it.across = null; }
  });
  const byId = new Map(ITEMS.map((it) => [String(it.id), it]));

  const factorOf = (item) => PACKING_FACTOR[item.type] !== undefined ? PACKING_FACTOR[item.type] : DEFAULT_PACKING_FACTOR;
  const itemVolume = (item) => item.cm[0] * item.cm[1] * item.cm[2] * factorOf(item);
  const fitsAtAll = (item) => { const d = [...item.cm].sort((a, b) => b - a), b = [BOX_L, BOX_W, BOX_H].sort((a, c) => c - a); return d[0] <= b[0] && d[1] <= b[1] && d[2] <= b[2]; };
  const footprint = (item) => { const d = [...item.cm].sort((a, b) => b - a); return { a: d[0], b: d[1], t: d[2] }; };
  const title = (item) => { const t = item.product; return item.brand && t.toLowerCase().startsWith(item.brand.toLowerCase()) ? t.slice(item.brand.length).trim() : t; };
  const brandTitle = (item) => (item.brand ? item.brand + ' ' : '') + title(item);
  const fullName = (item) => brandTitle(item) + (item.variant ? ', ' + item.variant : '');

  /* ---------- State ---------- */
  let budgetRm = DEFAULT_BUDGET_RM;
  let box = [];          // one entry per unit: { uid, id }
  let uidSeq = 1;
  let filter = null;
  const products = [], prodByTitle = new Map(), productOf = new Map();
  ITEMS.forEach((it) => {
    let p = prodByTitle.get(it.product);
    if (!p) { p = { key: 'p' + products.length, title: title(it), brand: it.brand, type: it.type, variants: [] }; products.push(p); prodByTitle.set(it.product, p); }
    p.variants.push(it); productOf.set(String(it.id), p);
  });
  const selected = new Map(products.map((p) => [p.key, String(p.variants[0].id)]));
  const countOf = (id) => box.reduce((n, e) => n + (e.id === id ? 1 : 0), 0);
  function totals() {
    let price = 0, grams = 0, volume = 0;
    box.forEach((e) => { const it = byId.get(e.id); price += it.price; grams += it.grams; volume += itemVolume(it); });
    return { price, grams, volume, fill: volume / (BOX_VOLUME_CM3 * BOX_USABLE_FRACTION) };
  }
  function canAdd(item) {
    const have = countOf(String(item.id));
    if (have >= item.stock) return { ok: false, reason: item.stock === 1 ? 'Only 1 in stock, and it is already in your box.' : 'Only ' + item.stock + ' in stock, and all ' + item.stock + ' are in your box.' };
    if (!fitsAtAll(item)) return { ok: false, reason: 'Too big for the box at any angle (' + item.cm.join(' x ') + ' cm). The inside is ' + BOX_L + ' x ' + BOX_W + ' x ' + BOX_H + ' cm.' };
    const t = totals(), need = itemVolume(item) / (BOX_VOLUME_CM3 * BOX_USABLE_FRACTION);
    if (t.fill + need > 1.0001) return { ok: false, reason: 'No room: the box is ' + pct(t.fill) + ' full and this needs ' + pct(need) + ' more.' };
    if (t.grams + item.grams > BOX_WEIGHT_LIMIT_G) return { ok: false, reason: 'Too heavy: the box would weigh ' + kg(t.grams + item.grams) + ' kg, the limit is ' + (BOX_WEIGHT_LIMIT_G / 1000) + ' kg.' };
    return { ok: true };
  }
  function addItem(id) { const item = byId.get(id); if (!item || !canAdd(item).ok) return; box.push({ uid: uidSeq++, id }); render(); }
  function removeOne(id) { for (let i = box.length - 1; i >= 0; i--) if (box[i].id === id) { box.splice(i, 1); break; } render(); }
  function removeAll(id) { box = box.filter((e) => e.id !== id); render(); }
  function setBudget(v) { budgetRm = Math.max(MIN_SPEND_RM, v); render(); }

  /* ---------- Packing, hand-packed look: a centred pile, tall at the back, flat at the front. Each unit keeps its spot. A new one
     takes the best nook on the paper, else rests on the lowest part of the pile: a height field in cm, so stacks stay level, every
     item rests on what is under it, and nothing is buried whole. Placement design from kimi-k3 (owner, 2026-10-27). ---------- */
  const placements = new Map(); // uid -> { x, y, w, h, t, z }; z = the height in cm the unit rests at
  const PARCEL_REST = Object.assign({ t: 99, z: 0 }, PARCEL_CM); // nothing rests on the mystery gift
  const inter = (r, o) => Math.max(0, Math.min(r.x + r.w, o.x + o.w) - Math.max(r.x, o.x)) * Math.max(0, Math.min(r.y + r.h, o.y + o.h) - Math.max(r.y, o.y));
  function rest(r, placed, cov) { // the height r would rest at, how much of it is held there, and the most of one item it would leave hidden
    let z = 0, held = 0, buries = 0;
    placed.forEach((o) => { if (inter(r, o) > 0.25) z = Math.max(z, o.z + o.t); });
    placed.forEach((o) => {
      const a = inter(r, o); if (a <= 0.25) return;
      if (o.z + o.t >= z - 1) held += a;
      buries = Math.max(buries, (a + (cov ? cov.get(o) || 0 : 0)) / (o.w * o.h)); // with what already lies on it
    });
    return { z, held: z === 0 ? 1 : held / (r.w * r.h), buries };
  }
  function scoreSpot(r, at, hN, uid, i, placed) {
    const wantY = 0.6 + (BOX_W - 1.2 - r.h) * (1 - hN);   // tall or standing at the back, low or flat at the front
    let s = Math.abs(r.y - wantY) / BOX_W * 1.2;
    s += Math.abs(r.x + r.w / 2 - BOX_L / 2) / BOX_L * 0.55; // gather around the middle of the bed
    if (at.z > 0) s += 0.6 + at.z * 0.06 + at.buries * 0.8; // free paper first, then the lowest part of the pile, covering little
    else if (placed.length > 1) {
      let touching = false;
      for (const o of placed) {
        const gx = Math.max(0, o.x - (r.x + r.w), r.x - (o.x + o.w)), gy = Math.max(0, o.y - (r.y + r.h), r.y - (o.y + o.h));
        if (o.z === 0 && gx + gy < 1.6) { touching = true; break; } // a hand tucks the new item against the ones already in
      }
      s += touching ? -0.14 : 0.25;
    }
    return s + seeded(uid * 41 + i) * 0.02;                 // deterministic tie-break: same box, same picture
  }
  function findSpot(placed, a, b, fixed, uid, hN, t) {
    const orients = fixed ? [[a, b]] : [[a, b], [b, a]];
    const jx = (seeded(uid * 17 + 5) - 0.5) * 2.2, jy = (seeded(uid * 29 + 7) - 0.5) * 1.6; // hand-placed offset, per unit
    const cand = [], seen = new Set();
    const push = (x, y, w, h, jit) => {
      if (jit) { x += jx; y += jy; }
      x = Math.round(Math.min(Math.max(x, 0), BOX_L - w) * 4) / 4; y = Math.round(Math.min(Math.max(y, 0), BOX_W - h) * 4) / 4;
      const k = x + ',' + y + ',' + w;
      if (!seen.has(k)) { seen.add(k); cand.push({ x, y, w, h }); }
    };
    orients.forEach(([w, h]) => {
      if (w > BOX_L || h > BOX_W) return;
      placed.forEach((o) => { // the natural tuck points around each item already packed, and on top of it
        push(o.x - w - 0.5, o.y, w, h, 1); push(o.x - w - 0.5, o.y + o.h - h, w, h, 1);
        push(o.x + o.w + 0.5, o.y, w, h, 1); push(o.x + o.w + 0.5, o.y + o.h - h, w, h, 1);
        push(o.x, o.y - h - 0.5, w, h, 1); push(o.x + o.w - w, o.y - h - 0.5, w, h, 1);
        push(o.x, o.y + o.h + 0.5, w, h, 1); push(o.x + o.w - w, o.y + o.h + 0.5, w, h, 1);
        push(o.x + (o.w - w) / 2, o.y + (o.h - h) / 2, w, h, 1);
      });
      push((BOX_L - w) / 2, (BOX_W - h) / 2, w, h, 1); push((BOX_L - w) / 2, 1, w, h, 1); push((BOX_L - w) / 2, BOX_W - h - 1, w, h, 1);
      for (let y = 0; y <= BOX_W - h; y += 3) for (let x = 0; x <= BOX_L - w; x += 3) push(x, y, w, h, 0); // a coarse sweep, so a spot always exists
    });
    let best = null, bestS = Infinity, hides = null, hidesS = Infinity, over = null, overS = Infinity;
    const cov = new Map(placed.map((o) => [o, placed.reduce((n, q) => (q !== o && q.z > o.z ? n + inter(q, o) : n), 0)])); // area already on top of each item
    cand.forEach((r, i) => {
      const at = rest(r, placed, cov);
      if (at.z >= 99 || at.held < 0.3) return;                // never on the mystery gift, never hanging in the air
      const s = scoreSpot(r, at, hN, uid, i, placed), spot = Object.assign(r, { t, z: at.z });
      if (at.z + t > BOX_H + 3) { if (!over || at.z < over.z || (at.z === over.z && s < overS)) { overS = s; over = spot; } } // a full box: the lowest spot
      else if (at.buries > 0.7) { const hs = Math.round(at.buries * 10) + s / 10; if (hs < hidesS) { hidesS = hs; hides = spot; } } // would hide most of an item below: only if nothing else fits, and then the spot that hides least
      else if (s < bestS) { bestS = s; best = spot; }         // a proper nook, every item below stays partly visible
    });
    if (best) best.ok = true; // `hides` and `over` are a full box's best effort, and trigger one repack
    return best || hides || over;
  }
  function placeItem(e, placed) {
    const item = byId.get(e.id), f = footprint(item), [a, b] = item.across || [f.a, f.b];
    const hN = item.upright ? 1 : item.flat ? 0 : Math.min(1, f.t / 16); // depth preference from standing height
    return findSpot(placed, a, b, !!item.across, e.uid, hN, f.t)
      || { x: (BOX_L - a) / 2, y: (BOX_W - b) / 2, w: a, h: b, t: f.t, z: placed.reduce((m, o) => o === PARCEL_REST ? m : Math.max(m, o.z + o.t), 0) };
  }
  function packBox(entries) {
    const live = new Set(entries.map((e) => e.uid)); let gone = false;
    placements.forEach((p, uid) => { if (!live.has(uid)) { placements.delete(uid); gone = true; } }); // forget units that left
    const placed = [PARCEL_REST];
    if (gone) { // let what rested on a removed item settle down onto what is left
      [...placements.entries()].sort((p, q) => p[1].z - q[1].z).forEach(([uid, p]) => { p.z = rest(p, placed).z; placed.push(p); });
    } else placements.forEach((p) => placed.push(p));
    const bySize = (p, q) => { const A = footprint(byId.get(p.id)), B = footprint(byId.get(q.id)); return (B.a * B.b - A.a * A.b) || (p.uid - q.uid); };
    const fresh = entries.filter((e) => !placements.has(e.uid));
    let repack = false;
    fresh.sort(bySize).forEach((e) => { const p = placeItem(e, placed); if (!p.ok) repack = true; placements.set(e.uid, p); placed.push(p); });
    if (repack && fresh.length < entries.length) { // no proper nook for a new item: repack the whole box once, biggest first, as a hand would
      placements.clear(); const all = [PARCEL_REST];
      [...entries].sort(bySize).forEach((e) => { const p = placeItem(e, all); placements.set(e.uid, p); all.push(p); });
    }
    return placements;
  }
  const seeded = (n) => { let t = (n * 2654435761) >>> 0; t ^= t >>> 15; t = Math.imul(t, 2246822519); t ^= t >>> 13; return (t >>> 0) / 4294967296; };

  /* ---------- Paper: paper hugging each item's near edges, in the colours of the real bed (owner, 2026-10-27) ---------- */
  const PAPER_PALETTE = [['#ecceba', 30], ['#f3d9c7', 25], ['#e3c3ab', 25], ['#d8b59b', 10], ['#fae3d3', 10]];
  const PAPER_WEIGHT = PAPER_PALETTE.reduce((n, p) => n + p[1], 0);
  const makeRnd = (seed) => { let s = seed | 0; return () => { s = (s + 0x6D2B79F5) | 0; let t = Math.imul(s ^ (s >>> 15), 1 | s); t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t; return ((t ^ (t >>> 14)) >>> 0) / 4294967296; }; };
  const pickPaper = (rnd) => { let r = rnd() * PAPER_WEIGHT; for (const [col, w] of PAPER_PALETTE) { if ((r -= w) <= 0) return col; } return PAPER_PALETTE[0][0]; };
  function strand(ctx, rnd, x, y, a, len, segs, wobble) {
    let px = x, py = y;
    const path = new Path2D(); path.moveTo(px, py);
    for (let seg = 0; seg < segs; seg++) {
      a += (rnd() - 0.5) * 1.6;
      const nx = px + Math.cos(a) * len / segs, ny = py + Math.sin(a) * len / segs;
      path.quadraticCurveTo((px + nx) / 2 + (rnd() - 0.5) * wobble, (py + ny) / 2 + (rnd() - 0.5) * wobble, nx, ny);
      px = nx; py = ny;
    }
    ctx.lineWidth = 1.7 + rnd() * 1.8;
    ctx.save(); ctx.translate(0.8, 1.2); ctx.strokeStyle = 'rgba(70,45,20,.14)'; ctx.stroke(path); ctx.restore();
    ctx.strokeStyle = pickPaper(rnd); ctx.stroke(path);
  }
  function drawShred(canvas, w, h, seed) {
    const OUTB = 20, OUTS = 13, OUTT = 8, dpr = 1.5; // the paper gathers at the front, so that side gets the margin
    const W = Math.ceil(w + 2 * OUTS), H = Math.ceil(h + OUTB + OUTT), ox = OUTS, oy = OUTT;
    canvas.width = W * dpr; canvas.height = H * dpr;
    canvas.style.cssText = 'left:' + (-ox) + 'px;top:' + (-oy) + 'px;width:' + W + 'px;height:' + H + 'px';
    const ctx = canvas.getContext('2d'), rnd = makeRnd(seed * 7919 + 11);
    ctx.scale(dpr, dpr); ctx.lineCap = 'round'; ctx.lineJoin = 'round';
    // a soft mound of paper bunched against the front edge, so the item reads as settled into the bed
    const mound = ctx.createLinearGradient(0, oy + h - 4, 0, oy + h + OUTB);
    mound.addColorStop(0, 'rgba(240,214,190,0)');
    mound.addColorStop(0.45, 'rgba(239,211,185,.5)');
    mound.addColorStop(1, 'rgba(239,211,185,0)');
    ctx.fillStyle = mound; ctx.fillRect(ox - 6, oy + h - 4, w + 12, OUTB + 4);
    // a loose fan of strands along the front, a few tips curling back over the item's edge
    const n = Math.max(5, Math.round(w / 15));
    for (let i = 0; i < n; i++) {
      const x = ox + ((i + 0.2 + rnd() * 0.6) / n) * w, y = oy + h - 2 + rnd() * 4;
      strand(ctx, rnd, x, y, Math.PI / 2 + (rnd() - 0.5) * 1.1, 13 + rnd() * 16, 3, 6);
      if (rnd() < 0.55) strand(ctx, rnd, x + (rnd() - 0.5) * 8, y - rnd() * 3, -Math.PI / 2 + (rnd() - 0.5) * 0.7, 5 + rnd() * 8, 2, 4);
    }
    // a couple of tucks low on each side, where a hand would fold the paper in
    for (let i = 0, ns = Math.max(2, Math.round(h / 26)); i < ns; i++) {
      const y = oy + h * (0.58 + 0.38 * rnd());
      strand(ctx, rnd, ox - 1 + rnd() * 2, y, Math.PI + (rnd() - 0.5) * 0.8, 7 + rnd() * 8, 3, 5);
      strand(ctx, rnd, ox + w + 1 - rnd() * 2, y, (rnd() - 0.5) * 0.8, 7 + rnd() * 8, 3, 5);
    }
  }
  /* ---------- Box picture ---------- */
  const stage = $('[data-stage]'), scene = $('[data-scene]'), hero = $('[data-hero]'), miniHome = $('[data-mini-home]'), minibar = $('[data-minibar]');
  stage.appendChild(document.createElement('div')).className = 'hkk-byo__light'; // one shared light over photo and items, outside the 3D scene so raised items stay under it
  const tiles = new Map();
  function fitStage() { const k = stage.parentElement.clientWidth / PHOTO_CROP.w; if (k > 0) stage.style.transform = 'scale(' + k + ')'; }
  const ro = new ResizeObserver(fitStage); ro.observe(hero); ro.observe(miniHome); // the section may be hidden on load; size it when it gets a size
  function positionTile(el, p, e) {
    const item = byId.get(e.id), upright = !!item.upright, flat = !!item.flat;
    const keepDrop = el.classList.contains('is-drop') ? ' is-drop' : '';
    const tilt = upright ? 0 : (seeded(e.uid * 3 + 1) - 0.5) * (flat ? 6 : 9); // small hand-placed rotation; an upright sprite keeps its footing
    // resting on other items: raised in the 3D scene so it sorts in front of them, at half height and without the perspective's
    // magnification, so a full box still reads as inside the box
    const hcm = footprint(item).t, rise = p.z * PX_PER_CM_X * RISE_SCALE, unzoom = 1 - rise * 0.94 / STAGE_PERSPECTIVE_PX;
    const grow = (upright ? 1 : 1 + HEIGHT_GROW_PER_10CM * hcm / 10) * unzoom;
    const w = p.w * PX_PER_CM_X, h = p.h * PX_PER_CM_Y;
    el.style.left = (FLOOR_PLANE.x - PHOTO_CROP.x + p.x * PX_PER_CM_X) + 'px';
    el.style.top = (FLOOR_PLANE.y - PHOTO_CROP.y + p.y * PX_PER_CM_Y) + 'px';
    el.style.width = w + 'px'; el.style.height = h + 'px';
    el.style.transform = 'translateZ(' + rise.toFixed(1) + 'px) rotate(' + tilt.toFixed(1) + 'deg) scale(' + grow.toFixed(3) + ')';
    el.style.zIndex = 10 + Math.round(p.z) * 40 + Math.round(p.y + p.h); // higher in the pile first, then nearer the front
    el.className = 'hkk-byo__tile' + (upright ? ' hkk-byo__tile--upright' : flat ? ' hkk-byo__tile--flat' : p.w / p.h > 2 ? ' hkk-byo__tile--slim' : '') + keepDrop;
    el.style.setProperty('--sh-y', (hcm * SHADOW_OFFSET_PX_PER_CM).toFixed(1) + 'px');
    el.style.setProperty('--sh-b', (hcm * SHADOW_BLUR_PX_PER_CM).toFixed(1) + 'px');
    const size = Math.round(w) + 'x' + Math.round(h);
    if (el.dataset.size !== size) { el.dataset.size = size; drawShred(el.querySelector('.hkk-byo__shred'), w, h, e.uid); }
  }
  function renderBox() {
    const placed = packBox(box), seen = new Set();
    let landed = false;
    box.forEach((e) => {
      seen.add(e.uid);
      let el = tiles.get(e.uid), isNew = !el;
      if (isNew) {
        const item = byId.get(e.id);
        el = document.createElement('div');
        el.title = fullName(item);
        el.innerHTML = '<i class="hkk-byo__bed"></i><div class="hkk-byo__tile-inner"><img alt="" src="' + esc(item.upright || item.flat || item.image) + '"></div><canvas class="hkk-byo__shred"></canvas><i class="hkk-byo__puff"></i>';
        tiles.set(e.uid, el);
      }
      positionTile(el, placed.get(e.uid), e);
      if (isNew) {
        scene.appendChild(el); landed = true;
        if (!reduceMotion.matches) {
          requestAnimationFrame(() => { // start the drop after first paint, and only once for this unit
            el.classList.add('is-drop');
            el.querySelector('.hkk-byo__tile-inner').addEventListener('animationend', () => el.classList.remove('is-drop'), { once: true });
          });
        }
      }
    });
    tiles.forEach((el, uid) => {
      if (seen.has(uid)) return;
      tiles.delete(uid); el.classList.add('is-lift');
      const done = () => el.remove();
      el.querySelector('.hkk-byo__tile-inner').addEventListener('animationend', done, { once: true }); setTimeout(done, 600);
    });
    if (landed && !reduceMotion.matches) { scene.classList.remove('is-thud'); void scene.offsetWidth; scene.classList.add('is-thud'); }
  }


  /* ---------- Status, list, cart bar ---------- */
  const STATUS_HTML = '<div class="hkk-byo__left"><strong class="js-left"></strong><span class="js-of"></span></div>'
    + '<div class="hkk-byo__meters"><div class="hkk-byo__meter"><div class="hkk-byo__meter-head"><span>Box fill</span><b class="js-fill-text"></b></div><div class="hkk-byo__bar" role="meter" aria-label="Box fill" aria-valuemin="0" aria-valuemax="100"><div class="hkk-byo__fill js-fill-bar"></div></div></div>'
    + '<div class="hkk-byo__meter"><div class="hkk-byo__meter-head"><span>Weight</span><b class="js-weight-text"></b></div><div class="hkk-byo__bar" role="meter" aria-label="Weight" aria-valuemin="0" aria-valuemax="' + (BOX_WEIGHT_LIMIT_G / 1000) + '"><div class="hkk-byo__fill js-weight-bar"></div></div></div></div>';
  $$('[data-status]').forEach((st) => { st.innerHTML = STATUS_HTML; });
  const barClass = (share) => 'hkk-byo__fill ' + (share >= 0.999 ? 'is-full' : share >= 0.8 ? 'is-warn' : '');
  function renderStatus(t) {
    const budget = rm(budgetRm), left = budget - t.price;
    $$('[data-status]').forEach((st) => {
      const l = st.querySelector('.js-left');
      l.textContent = left >= 0 ? money(left) + ' left' : '+' + money(-left) + ' above budget';
      l.classList.toggle('is-over', left < 0);
      st.querySelector('.js-of').textContent = 'of your ' + money(budget) + ' budget';
      st.querySelector('.js-fill-text').textContent = pct(Math.min(t.fill, 1)) + ' full';
      const fb = st.querySelector('.js-fill-bar'); fb.style.width = Math.min(t.fill, 1) * 100 + '%'; fb.className = barClass(t.fill) + ' js-fill-bar';
      fb.parentElement.setAttribute('aria-valuenow', Math.round(Math.min(t.fill, 1) * 100));
      const ws = t.grams / BOX_WEIGHT_LIMIT_G, wb = st.querySelector('.js-weight-bar');
      st.querySelector('.js-weight-text').textContent = kg(t.grams) + ' of ' + (BOX_WEIGHT_LIMIT_G / 1000) + ' kg';
      wb.style.width = Math.min(ws, 1) * 100 + '%'; wb.className = barClass(ws) + ' js-weight-bar';
      wb.parentElement.setAttribute('aria-valuenow', (t.grams / 1000).toFixed(2));
    });
    $$('[data-budget-rm]').forEach((b) => b.setAttribute('aria-pressed', String(+b.dataset.budgetRm === budgetRm)));
    $('[data-budget-value]').textContent = money(budget);
    $('[data-budget-step="-1"]').disabled = budgetRm <= MIN_SPEND_RM;
  }
  const grouped = () => { const g = new Map(); box.forEach((e) => g.set(e.id, (g.get(e.id) || 0) + 1)); return [...g].map(([id, n]) => ({ item: byId.get(id), n })); };
  function renderList(t) {
    const rows = grouped();
    $('[data-empty]').hidden = rows.length > 0;
    $('[data-count]').textContent = box.length ? box.length + (box.length === 1 ? ' item' : ' items') : '';
    $('[data-list]').innerHTML = rows.map(({ item, n }) => {
      const id = String(item.id), can = canAdd(item);
      return '<li><img alt="" loading="lazy" src="' + esc(item.image) + '">'
        + '<div><div class="hkk-byo__name">' + esc(brandTitle(item)) + '</div><div class="hkk-byo__sub">' + esc(item.variant ? item.variant + ' · ' : '') + n + ' x ' + money(item.price) + ' = ' + money(n * item.price) + '</div></div>'
        + '<div class="hkk-byo__qty"><button type="button" class="hkk-byo__step" data-act="minus" data-id="' + id + '" aria-label="One less ' + esc(fullName(item)) + '">&minus;</button><output aria-label="Quantity">' + n + '</output>'
        + '<button type="button" class="hkk-byo__step" data-act="plus" data-id="' + id + '" aria-label="One more ' + esc(fullName(item)) + '"' + (can.ok ? '' : ' disabled') + '>+</button>'
        + '<button type="button" class="hkk-byo__remove" data-act="remove" data-id="' + id + '" aria-label="Remove ' + esc(fullName(item)) + '">Remove</button></div></li>';
    }).join('');
    $('[data-items-total]').textContent = money(t.price);
    $('[data-grand]').textContent = money(t.price);
    $('[data-cart-total]').textContent = money(t.price);
    const short = rm(MIN_SPEND_RM) - t.price;
    $('[data-add-to-cart]').disabled = short > 0;
    $('[data-cart-note]').hidden = short <= 0;
    if (short > 0) $('[data-cart-note]').textContent = 'Minimum spend is ' + money(rm(MIN_SPEND_RM)) + '. Add ' + money(short) + ' more.';
  }
  $('[data-list]').addEventListener('click', (ev) => {
    const b = ev.target.closest('button[data-act]'); if (!b) return;
    if (b.dataset.act === 'minus') removeOne(b.dataset.id); else if (b.dataset.act === 'plus') addItem(b.dataset.id); else removeAll(b.dataset.id);
  });

  /* ---------- Shelf ---------- */
  const types = [...new Set(products.map((p) => p.type).filter(Boolean))].sort();
  function renderFilters() {
    const f = $('[data-filters]');
    f.innerHTML = ['All'].concat(types).map((t, i) => '<button type="button" class="hkk-byo__filter" data-type="' + esc(i ? t : '') + '" aria-pressed="' + String(i === 0) + '">' + esc(t) + '</button>').join('');
    f.addEventListener('click', (ev) => {
      const b = ev.target.closest('.hkk-byo__filter'); if (!b) return;
      filter = b.dataset.type || null;
      [...f.children].forEach((c) => c.setAttribute('aria-pressed', String(c === b)));
      applyFilter();
    });
  }
  function applyFilter() {
    let shown = 0;
    products.forEach((p) => { const show = !filter || p.type === filter; $('#hkk-byo-card-' + p.key).hidden = !show; if (show) shown++; });
    $('[data-shelf-hint]').textContent = products.length + ' products, ' + ITEMS.length + ' options in stock today' + (filter ? ', showing ' + shown : '') + '.';
  }
  function renderShelf() {
    const cards = $('[data-cards]');
    cards.innerHTML = products.map((p) => {
      const sel = p.variants.length > 1
        ? '<label class="hkk-byo__vh" for="hkk-byo-var-' + p.key + '">Option</label><select class="hkk-byo__variant" id="hkk-byo-var-' + p.key + '" data-key="' + p.key + '">' + p.variants.map((v) => '<option value="' + v.id + '">' + esc(v.variant) + '</option>').join('') + '</select>'
        : '';
      return '<article class="hkk-byo__card" id="hkk-byo-card-' + p.key + '" aria-labelledby="hkk-byo-title-' + p.key + '"><div class="hkk-byo__card-media"><img alt="" loading="lazy" width="96" height="96" class="js-img"></div><div class="hkk-byo__card-body">'
        + '<div class="hkk-byo__brand">' + esc([p.brand, p.type].filter(Boolean).join(' · ')) + '</div><h4 class="hkk-byo__title" id="hkk-byo-title-' + p.key + '">' + esc(p.title) + '</h4>' + sel
        + '<div class="hkk-byo__price-row"><span class="hkk-byo__price js-price" data-hkk-money></span><span class="hkk-byo__pill hkk-byo__pill--clear js-clear" hidden>Clearance</span><span class="hkk-byo__pill js-stock" hidden></span></div>'
        + '<div class="hkk-byo__effect js-effect"></div><p class="hkk-byo__note js-note" hidden></p>'
        + '<div class="hkk-byo__actions"><button type="button" class="hkk-byo__btn js-add" data-key="' + p.key + '">Add to box</button>'
        + '<span class="hkk-byo__qty js-qty" hidden><button type="button" class="hkk-byo__step js-minus" aria-label="One less">&minus;</button><output class="js-n" aria-label="In your box"></output><button type="button" class="hkk-byo__step js-plus" aria-label="One more">+</button></span><span class="hkk-byo__inbox-txt js-inbox"></span></div>'
        + '</div></article>';
    }).join('');
    cards.addEventListener('change', (ev) => {
      const s = ev.target.closest('select.hkk-byo__variant'); if (!s) return;
      selected.set(s.dataset.key, s.value); refreshCard(products.find((p) => p.key === s.dataset.key), totals());
    });
    cards.addEventListener('click', (ev) => {
      const card = ev.target.closest('.hkk-byo__card'); if (!card) return;
      const id = selected.get(card.id.replace('hkk-byo-card-', ''));
      if (ev.target.closest('.js-add, .js-plus')) addItem(id); else if (ev.target.closest('.js-minus')) removeOne(id);
    });
  }
  function refreshCard(p, t) {
    const card = $('#hkk-byo-card-' + p.key), v = byId.get(selected.get(p.key));
    const img = card.querySelector('.js-img'); if (img.getAttribute('src') !== v.image) img.src = v.image;
    const sel = card.querySelector('select'); if (sel && sel.value !== String(v.id)) sel.value = String(v.id);
    card.querySelector('.js-price').textContent = money(v.price);
    card.querySelector('.js-clear').hidden = !v.clearance;
    const stockPill = card.querySelector('.js-stock'); stockPill.hidden = v.stock > 3; stockPill.textContent = 'Only ' + v.stock + ' left';
    const n = countOf(String(v.id)), can = canAdd(v), left = rm(budgetRm) - t.price - v.price;
    const eff = card.querySelector('.js-effect');
    eff.textContent = '+' + money(v.price) + ' · ' + (left >= 0 ? money(left) + ' left' : money(-left) + ' over your budget');
    eff.classList.toggle('is-over', left < 0);
    const note = card.querySelector('.js-note'); note.hidden = can.ok; note.textContent = can.ok ? '' : can.reason;
    card.querySelector('.js-add').hidden = n > 0; card.querySelector('.js-add').disabled = !can.ok;
    card.querySelector('.js-qty').hidden = n === 0; card.querySelector('.js-n').value = n; card.querySelector('.js-plus').disabled = !can.ok;
    card.querySelector('.js-inbox').textContent = n > 0 ? 'in your box' : '';
  }

  /* ---------- Budget controls ---------- */
  $('[data-chips]').innerHTML = BUDGET_PRESETS_RM.map((b) => '<button type="button" class="hkk-byo__chip" data-budget-rm="' + b + '" aria-pressed="false">' + money(rm(b)) + '</button>').join('');
  $('[data-chips]').addEventListener('click', (ev) => { const b = ev.target.closest('[data-budget-rm]'); if (b) setBudget(+b.dataset.budgetRm); });
  $$('[data-budget-step]').forEach((b) => b.addEventListener('click', () => setBudget(budgetRm + BUDGET_STEP_RM * +b.dataset.budgetStep)));
  $('[data-budget-hint]').textContent = 'From ' + money(rm(MIN_SPEND_RM)) + ', in steps of ' + money(rm(BUDGET_STEP_RM)) + '. Going over is fine: we show it plainly and you decide.';
  const msg = section.querySelector('textarea'), msgCount = $('[data-msg-count]');
  msg.addEventListener('input', () => { msgCount.textContent = msg.value.length; });

  /* ---------- Add to cart: the gift box line first, then each chosen variant, tied by _gift_id ---------- */
  const error = $('[data-error]'), addBtn = $('[data-add-to-cart]');
  addBtn.addEventListener('click', async () => {
    const t = totals();
    if (t.price < rm(MIN_SPEND_RM) || !box.length) return;
    error.hidden = true;
    const gift = Date.now().toString(36);
    const props = { 'Gift set': 'BYO Gift Set', 'Budget': money(rm(budgetRm)), _gift_id: gift };
    if (msg.value.trim()) props['Gift message'] = msg.value.trim();
    const items = [{ id: BOX_ID, quantity: 1, properties: props }].concat(grouped().map(({ item, n }) => ({ id: item.id, quantity: n, properties: { _gift_id: gift } })));
    addBtn.disabled = true;
    try {
      const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items })
      });
      if (!res.ok) throw new Error((await res.json()).description || 'Could not add to cart.');
      window.location.href = window.Shopify.routes.root + 'cart';
    } catch (err) {
      error.textContent = err.message + ' Please try again, or WhatsApp us.';
      error.hidden = false; addBtn.disabled = false;
    }
  });

  /* ---------- Once the big box scrolls away, a compact bar takes the picture and the meters, only while this section is in view ---------- */
  let compact = false;
  function headerTop() { const h = document.querySelector('.hdt-section-header'); return h ? Math.max(0, Math.round(h.getBoundingClientRect().bottom)) : 0; } // where the header ends on screen: 0 once it has scrolled away
  function toolbarHeight() { const t = document.querySelector('.hdt-toolbar'); return t && getComputedStyle(t).display !== 'none' ? t.offsetHeight : 0; } // the theme's bottom bar on phones
  function onScroll() {
    const top = headerTop();
    section.style.setProperty('--hkk-top', top + 'px');
    section.style.setProperty('--hkk-bottom', toolbarHeight() + 'px');
    const r = section.getBoundingClientRect();
    const visible = r.height > 0 && r.bottom > top + 140 && r.top < window.innerHeight; // hidden ancestor (the Omakase path is showing) or scrolled past: no bar
    const want = visible && hero.getBoundingClientRect().bottom < top + 8;
    if (want === compact) return;
    compact = want;
    (compact ? miniHome : hero).appendChild(stage);
    minibar.hidden = !compact;
    fitStage();
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  /* ---------- Go ---------- */
  function render() { const t = totals(); renderStatus(t); renderList(t); products.forEach((p) => refreshCard(p, t)); renderBox(); }
  $('[data-parcel]').appendChild(document.createElement('canvas')).className = 'hkk-byo__shred';
  drawShred($('[data-parcel]').lastChild, PARCEL_CM.w * PX_PER_CM_X, PARCEL_CM.h * PX_PER_CM_Y, 4242);
  renderFilters(); renderShelf(); applyFilter();
  render(); fitStage(); onScroll();
})();
